import axios from 'axios'

export const performRequest_GET = (url, params, headers) => {
    return axios.get( url, { params: params, headers: headers} )
        .then(resp => {
            return {success: true, response: resp}
        })
        .catch(err => {
            return {success: false, error: err}
        })
}

export const performRequest_POST = (url, data, headers) => {
    return axios.post( url, data, {headers: headers} )
        .then(resp => {
            return {success: true, response: resp}
        })
        .catch(err => {
            return {success: false, error: err}
        })
}

export const performRequest_PUT = (url, data, headers) => {
    return axios.put( url, data, {headers: headers} )
        .then(resp => {
            return {success: true, response: resp}
        })
        .catch(err => {
            return {success: false, error: err}
        })
}


// WEBPACK FOOTER //
// ./src/platform/utils/http/httpService.js